import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { withAppContext } from '../contexts/app';

import LogoOnDark from 'images/ask/logo-text-white.svg';

class Footer extends Component {

  render() {
    const { isOfflineMode } = this.props.app;

    return (
      <div className="footer">

        <div className="footer__top">
          <div className="container">
            <div className="footer__logo">
              <Link to="/"><img src={LogoOnDark} /></Link>
            </div>

            {!isOfflineMode && (
              <div className="footer__links">
                <Link to="/about">About</Link>
                <Link to="/health">Skin Health A-Z</Link>
                <Link to="/clinical">Clinical Solutions</Link>
                {/*<Link to="/">Careers</Link>*/}
                {/*<Link to="/">API</Link>*/}
                <Link to="/terms">Terms</Link>
                <Link to="/terms#privacy_policy">Privacy</Link>
                {/*<Link to="/">Contact us</Link>*/}
              </div>
            )}
          </div>
        </div>

        <div className="footer__bottom">
          <div className="container">
            <div className="footer__left footer__copyright">
              &copy; Triage 2019
            </div>
          </div>
        </div>

      </div>
    );
  }

}

Footer.propTypes = {
  app: PropTypes.object.isRequired
};

export { Footer };

export default withAppContext(Footer);
